import React from 'react'
import { Title, Subtitle, Link2, IconText } from '../../../index.js'
import { isLocal } from '../../../../../global/environments/index.js'
import DOMPurify from 'dompurify'
import '../../../../../components/EmailSubscriptionCenter/Modal/CategorySubscriptionButtonElement.js'

function InstitutionalBlogArticleCard({ item, taxonomies, children }) {
  const {
    title,
    publicationDate,
    cardSummary,
    time,
    types = [],
  } = item.document.getData()
  const { imageUrl } = item.processedFields

  const prefix = isLocal()
    ? '/site/cti-institutional/insights/latest-insights'
    : '/institutional/insights/latest-insights'

  const articlePath = DOMPurify.sanitize(
    `${prefix}/${item?.processedFields?.path}`
  )

  const publishDate =
    publicationDate &&
    new Date(publicationDate).toLocaleDateString('en-us', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    })

  const footer = () => {
    return (
      <>
        {(time || types?.length || item?.processedFields?.keys?.length) && (
          <div className="u-marginTop4gu u-sizeFull">
            <hr className="Rule Rule--thin u-marginBottom3gu" />
            <div className="u-flex">
              <div className="u-size3of8">
                {types?.map((type, index) => (
                  <IconText key={index} icon={type} text={type} />
                ))}
                {time ? <IconText icon="Time" text={time} /> : ''}
              </div>
              <div
                className="u-flex u-flexCol u-flexAlignItemsEnd u-size5of8"
                style={{ minHeight: 76 }}
              >
                {item?.processedFields?.keys?.map((key, index) => (
                  <React.Fragment key={key}>
                    {key && key !== 'client-materials' && (
                      <div
                        className="u-textColorBrandLight u-textItalic u-textCapitalize u-textSizeMsrm1"
                        style={{
                          marginTop: index > 0 ? 5 : 2,
                          paddingTop: 2,
                          paddingBottom: 2,
                        }}
                      >
                        <a
                          className="u-flex u-flexAlignItemsCenter u-textRight"
                          href={`${prefix}?topic=${key}`}
                        >
                          {(taxonomies?.length > 0 &&
                            taxonomies.find((taxonomy) => taxonomy.key === key)
                              ?.name) ||
                            key.replaceAll('-', ' ')}
                        </a>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
        )}
      </>
    )
  }

  const authorInfo = () => {
    const list = item?.processedFields?.authors || []
    return (
      <>
        {list?.length > 0 ? (
          <div className="u-textSecondary u-textColorLight  u-textSizeMsrm1 u-inline u-marginLeft1gu u-marginRight1gu">
            |
          </div>
        ) : (
          ''
        )}
        {list?.map((author, index) => (
          <div
            key={index}
            className="u-textSecondary u-textColorLight  u-textSizeMsrm1 u-inline"
          >
            {index > 0 ? '; ' : ''}
            {author?.displayName && author.title
              ? `${author?.displayName}, ${author.title}`
              : author?.displayName
              ? `${author?.displayName}`
              : author.title
              ? `${author?.title}`
              : ''}
          </div>
        ))}
      </>
    )
  }

  return (
    <div
      className="u-flex u-flexCol u-bgColorWhite u-decoBorderLightFull u-marginBottom5gu u-sm-sizeFull u-md-size1of3 u-lg-size1of3"
      data-analytics="insights-card"
    >
      <div className="BlogArticleCard u-posRelative u-flex u-flexCol u-flexAlignItemsStart u-flexAuto u-sizeFull">
        {children}
        <a
          href={DOMPurify.sanitize(articlePath)}
          target="_self"
          className="u-sizeFull"
        >
          <div
            className="banner-background-image u-block u-posRelative u-flexAlignItemsCenter blog-article-image-link"
            data-analytics="insights-card-img"
            style={
              imageUrl ? { backgroundImage: 'url("' + imageUrl + '")' } : {}
            }
            alt="img"
            aria-label={title}
          ></div>
        </a>
        <div className="u-flex u-flexCol u-flexAuto u-sizeFull u-padding4gu u-flexAlignItemsStart">
          <Link2 url={articlePath} className="u-textColorBrandLight">
            <Title
              text={title}
              textColor="u-textColorBrandLight"
              mode="medium-large"
              data-analytics="insights-card-headline"
            />
          </Link2>
          <div className="u-marginTop2gu">
            {publishDate && (
              <Subtitle
                text={publishDate}
                mode="small-bold"
                className="u-inline"
              />
            )}
            {authorInfo()}
          </div>
          <div className="u-flex u-flexCol u-flexAuto u-sizeFull">
            <div className="Content u-flexAuto u-paddingBottom0">
              {cardSummary && <p>{cardSummary}</p>}
            </div>
            {footer()}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InstitutionalBlogArticleCard
